import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
export default {
  name: "testpage",
  data: function data() {
    return {
      searchData: [{
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: "",
        system_info: "",
        device_model: "",
        server_id: "",
        user_id: "",
        role_id: "",
        order_id: "",
        level: "",
        amount: "",
        currency: "",
        product_id: "",
        product_name: "",
        ip: ""
      }],
      searchDataMode: {},
      // 激活
      activityData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: "",
        system_info: "",
        device_model: "",
        ip: ""
      },
      // 创角
      create_roleData: {
        game: "",
        platform: "",
        pkg: "",
        channel: "",
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: '',
        system_info: "",
        device_model: "",
        role_id: "",
        user_id: "",
        ip: ""
      },
      // 注册 
      registerData: {
        game: "",
        platform: "",
        pkg: "",
        channel: "",
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: '',
        system_info: "",
        device_model: "",
        server_id: "",
        user_id: "",
        ip: ""
      },
      //  登录
      loginData: {
        game: "",
        platform: "",
        pkg: "",
        channel: "",
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: '',
        system_info: "",
        device_model: "",
        server_id: "",
        user_id: "",
        ip: ""
      },
      // 充值
      rechargeData: {
        game: "",
        platform: "",
        pkg: "",
        channel: "",
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: '',
        system_info: "",
        device_model: "",
        server_id: "",
        role_id: "",
        user_id: "",
        order_id: "",
        level: "",
        amount: "",
        currency: "",
        product_id: "",
        product_name: "",
        ip: ""
      },
      // 在线
      online_userData: {
        game: "",
        platform: "",
        pkg: "",
        channel: "",
        ad_channel: "",
        ad_placement: "",
        device_id: "",
        timestamp: '',
        system_info: "",
        device_model: "",
        server_id: "",
        user_id: "",
        ip: ""
      },
      //资源上报
      resourceData: {
        game: "",
        platform: "",
        pkg: "",
        channel: "",
        ad_channel: "default",
        ad_placement: "default",
        device_id: "",
        timestamp: '',
        system_info: "",
        device_model: "",
        server_id: "",
        user_id: "",
        level: "",
        action: "test",
        resource: "",
        role_id: "",
        ip: ""
      },
      activity: {
        "func": "activity",
        "game": "yjfm_qtld",
        "platform": "android",
        "pkg": "com.qtld.yjfm",
        "channel": "qtld",
        "ad_channel": "",
        "ad_placement": "",
        'server_id': '600001',
        "device_id": "",
        "timestamp": 1736221382,
        "system_info": "android",
        "device_model": "android",
        "ip": "171.213.151.230"
      },
      create_role: {
        "func": "create_role",
        "game": "yjfm_qtld",
        "platform": "android",
        "pkg": "com.qtld.yjfm",
        "channel": "qtld",
        "ad_channel": "",
        "ad_placement": "",
        'server_id': '600001',
        "device_id": "",
        "timestamp": 1736221382,
        "system_info": "android",
        "device_model": "android",
        "role_id": "",
        "user_id": "",
        "ip": "171.213.151.230"
      },
      register: {
        "func": "register",
        "game": "yjfm_qtld",
        "platform": "android",
        "pkg": "com.qtld.yjfm",
        "channel": "qtld",
        "ad_channel": "",
        "ad_placement": "",
        'server_id': '600001',
        "device_id": "",
        "timestamp": 1736221382,
        "system_info": "android",
        "device_model": "android",
        "role_id": "",
        "user_id": "",
        "ip": "171.213.151.230"
      }
    };
  },
  created: function created() {
    // this.ccc()
    var data = {
      output: {
        10001: 100
      },
      cost: {
        10001: 20
      },
      retain: {
        10001: 30
      }
    };
    this.resourceData.resource = JSON.stringify(data);
    this.searchDataMode = JSON.parse(JSON.stringify(this.searchData[0]));
  },
  methods: {
    addList: function addList() {
      this.searchData.push(JSON.parse(JSON.stringify(this.searchDataMode)));
    },
    removeList: function removeList(index) {
      this.searchData.splice(index, 1);
    },
    searchClick: function searchClick(func) {
      var _this = this;

      var data = {
        func: func
      };
      this.searchData.forEach(function (item) {
        for (var i in _this[func + 'Data']) {
          data[i] = item[i] || _this[func + 'Data'][i];
        }

        data.timestamp = data.timestamp / 1000; // axios.post('http://datacenter-data-test.onemgames.com/api/data/report', data).then(res => {
        //   if (res.data.code == 1000) {
        //     this.$message('上报成功')
        //   }
        // })
      });
    },
    ccc: function ccc() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dataList, funcList, i, k, reqData, h;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataList = [{
                  "id": 1151,
                  "user": "0c17831b-91d4-45ad-a4bd-2764764b27f2",
                  "playerid": "100000905",
                  "deviceid": "8d7fdc552126e00ebaa7b28b6e507cdf",
                  "time": "1742991843"
                }, {
                  "id": 1152,
                  "user": "0d84613f-c045-4d9c-8966-4b21bf86c829",
                  "playerid": "100000266",
                  "deviceid": "c25699b072919d81a08236ecb2e201ee",
                  "time": "1742983918"
                }, {
                  "id": 1153,
                  "user": "0e2a4d66-69c7-41f9-8e58-fb44719302d6",
                  "playerid": "100000198",
                  "deviceid": "4d44f6817298b2ee3c0b82d7fbef52dc",
                  "time": "1742982575"
                }, {
                  "id": 1154,
                  "user": "12f32d91-0057-4326-a1f6-d963c1574f71",
                  "playerid": "100000720",
                  "deviceid": "6d8286d915402a2c5a142551c62940f1",
                  "time": "1742988547"
                }, {
                  "id": 1155,
                  "user": "1f577b18-75be-4595-87c1-b4e404934d21",
                  "playerid": "100000359",
                  "deviceid": "fbfda72a20b2e03c2474ea6d6c3b37b4",
                  "time": "1742984903"
                }, {
                  "id": 1156,
                  "user": "222969db-8b8d-4242-b990-82c4d3f7f1fe",
                  "playerid": "100001069",
                  "deviceid": "9b8d29ff8a4187e9679c57ff5e1b6868",
                  "time": "1743016144"
                }, {
                  "id": 1157,
                  "user": "2239a858-ce6f-4a86-b209-d779594da88d",
                  "playerid": "100000056",
                  "deviceid": "423d5982c4ecd6ce254f4912fa885ce4",
                  "time": "1742978280"
                }, {
                  "id": 1158,
                  "user": "27d0b3a4-07f9-41a1-b702-29b51d31e1e6",
                  "playerid": "100000524",
                  "deviceid": "44b457bd802137368c6f176ec77081ca",
                  "time": "1742986209"
                }, {
                  "id": 1159,
                  "user": "2846fd1b-21c5-49a6-906e-8620d849e723",
                  "playerid": "100000023",
                  "deviceid": "1355f76bfb798989ab0939746b6fb730",
                  "time": "1742972649"
                }, {
                  "id": 1160,
                  "user": "28672d57-ea93-480b-9e15-c4ba318cde91",
                  "playerid": "100000569",
                  "deviceid": "c1d6e153c7d470a6bf80703bd08dcbd1",
                  "time": "1742986546"
                }, {
                  "id": 1161,
                  "user": "2873cbb3-bdfa-4e58-8e74-438643a9f33e",
                  "playerid": "100000182",
                  "deviceid": "eb2c2ca43edb479c11186eff9fc099bc",
                  "time": "1742982237"
                }, {
                  "id": 1162,
                  "user": "2af250a1-a32c-4840-9e22-a634c7a0666a",
                  "playerid": "100000181",
                  "deviceid": "8001bb16553157be11d5aba3edd2d720",
                  "time": "1742982231"
                }, {
                  "id": 1163,
                  "user": "329554d6-be25-4059-a899-18c6c669f696",
                  "playerid": "100000073",
                  "deviceid": "af372fb3e93be5b39bc5fdc20a4b0df9",
                  "time": "1742978958"
                }, {
                  "id": 1164,
                  "user": "33a0d923-151f-44c6-bc19-62e01ef0e56a",
                  "playerid": "100000525",
                  "deviceid": "1f4e1fb0129ed5bce27772b688ee2889",
                  "time": "1742986213"
                }, {
                  "id": 1165,
                  "user": "3b05c330-ca65-4b9e-a9ce-c93d174f206e",
                  "playerid": "100000931",
                  "deviceid": "7d56f0af5066c0cbe0a640c566ad9d82",
                  "time": "1742993148"
                }, {
                  "id": 1166,
                  "user": "407c5543-ee0e-412e-9498-46431147e219",
                  "playerid": "100000028",
                  "deviceid": "1302f221534748efd692fbf38b797669",
                  "time": "1742973648"
                }, {
                  "id": 1167,
                  "user": "42dd3ae7-412a-4e77-8050-d1ce4db349cb",
                  "playerid": "100000183",
                  "deviceid": "153e1ce9aa9a101731cfcda19ac9dd4d",
                  "time": "1742982248"
                }, {
                  "id": 1168,
                  "user": "47f44eb9-28d4-45cf-ab3b-d898bbe4706d",
                  "playerid": "100001013",
                  "deviceid": "81bbb13bcf1bd457d8314ab5f7232ab1",
                  "time": "1743001360"
                }, {
                  "id": 1169,
                  "user": "4aa91216-6e1e-4854-94fb-731e167f04d7",
                  "playerid": "100001019",
                  "deviceid": "96f27b3eaee660d3604afd36998332a5",
                  "time": "1743001683"
                }, {
                  "id": 1170,
                  "user": "57c6e4b5-0353-446d-875a-a193b351ef3f",
                  "playerid": "100000862",
                  "deviceid": "25d3b3206b6be6910ed5f09832c3c281",
                  "time": "1742990533"
                }, {
                  "id": 1171,
                  "user": "671bf143-7dc0-4983-8bb6-955b3f5ac48f",
                  "playerid": "100000153",
                  "deviceid": "8c398d3064f7556ca0cbc0b4576cb79c",
                  "time": "1742981588"
                }, {
                  "id": 1172,
                  "user": "685175d7-b86c-4736-b92a-9e92a70f6bfb",
                  "playerid": "100001009",
                  "deviceid": "cf357b53b0d6c26cd3d64ebc4495e806",
                  "time": "1743000373"
                }, {
                  "id": 1173,
                  "user": "766fc13c-832d-4639-bfe2-4d3e3427a911",
                  "playerid": "100000154",
                  "deviceid": "fbbc476d4e3f8ef1592f25dcc47d21f1",
                  "time": "1742981591"
                }, {
                  "id": 1174,
                  "user": "769bc3ad-aea1-497d-ad3a-6aef0864dd8d",
                  "playerid": "100001080",
                  "deviceid": "396cc17ac0cce7664bfc54d9d6b86e6e",
                  "time": "1743029692"
                }, {
                  "id": 1175,
                  "user": "7c6922d3-d70a-4b38-8ae8-15dc514306db",
                  "playerid": "100000297",
                  "deviceid": "26776a94fdff69fa24fe28a0f6f2d545",
                  "time": "1742984261"
                }, {
                  "id": 1176,
                  "user": "7eaff519-aaf6-4109-8810-dbc0aa21123d",
                  "playerid": "100000358",
                  "deviceid": "08b892746df6ed6127922ddd807c98c1",
                  "time": "1742984901"
                }, {
                  "id": 1177,
                  "user": "7f5d85b7-b26c-4ecd-8602-cc67fb18a03a",
                  "playerid": "100001039",
                  "deviceid": "29ef2fd5-509b-4256-8084-f265947b3a48",
                  "time": "1743003682"
                }, {
                  "id": 1178,
                  "user": "815fbc5f-0ffa-44c6-a1eb-5577063307a6",
                  "playerid": "100000298",
                  "deviceid": "e30897675417d19631478e42af0c4438",
                  "time": "1742984265"
                }, {
                  "id": 1179,
                  "user": "86ee791e-11b3-4b1e-b4bc-3bf87a875307",
                  "playerid": "100000977",
                  "deviceid": "8505f89d683f2c92dd5c3463b8a1e36f",
                  "time": "1742996442"
                }, {
                  "id": 1180,
                  "user": "871dad20-3874-4984-bbba-b7d2d8ae6783",
                  "playerid": "100000413",
                  "deviceid": "f9983fd10a5a0f295c385329e83d7382",
                  "time": "1742985221"
                }, {
                  "id": 1181,
                  "user": "88ee05a6-119f-4831-bbce-97fdebe579b9",
                  "playerid": "100000526",
                  "deviceid": "ce1a3ce884e477acf4c74ec2405cb190",
                  "time": "1742986219"
                }, {
                  "id": 1182,
                  "user": "894dd38b-8c86-4547-baef-357b2d568bed",
                  "playerid": "100000267",
                  "deviceid": "a9e372548bbb3cfde0ac40497b44c78c",
                  "time": "1742983918"
                }, {
                  "id": 1183,
                  "user": "8bb63106-fcbf-476f-8a84-bbb0c5beee47",
                  "playerid": "100000049",
                  "deviceid": "35e281f17450e5b0de13a44efd8af771",
                  "time": "1742977951"
                }, {
                  "id": 1184,
                  "user": "97ac1914-9122-4646-97e1-beed8ecd5585",
                  "playerid": "100000296",
                  "deviceid": "610611b4530dc6d05b699e65769b3f57",
                  "time": "1742984260"
                }, {
                  "id": 1185,
                  "user": "9dc233ef-5f9b-4eb6-8085-ef38c6aab853",
                  "playerid": "100000237",
                  "deviceid": "6702c6ff348b54965485204edbddee01",
                  "time": "1742983251"
                }, {
                  "id": 1186,
                  "user": "a00163f8-0c5b-4a86-bed9-3faf713189ac",
                  "playerid": "100000238",
                  "deviceid": "04c44678778f99b8e8b3b9cf6f8ea463",
                  "time": "1742983255"
                }, {
                  "id": 1187,
                  "user": "a36c0122-4212-4966-b8c2-764137bcadd7",
                  "playerid": "100000415",
                  "deviceid": "c5cbe74c76464e82150d824c7070cc73",
                  "time": "1742985228"
                }, {
                  "id": 1188,
                  "user": "a5c8b18d-7181-405f-be62-df8e47bb5c61",
                  "playerid": "100001029",
                  "deviceid": "6504b2d7029bc1b57cc48c9da488d5bc",
                  "time": "1743002699"
                }, {
                  "id": 1189,
                  "user": "aa1935a2-ad2a-4cdd-836f-e069d1ff5791",
                  "playerid": "100000391",
                  "deviceid": "f40f38894cecfcd4fc5339bbb8bf8bbc4366ae93a98351ea903f4dc072373e17",
                  "time": "1742985109"
                }, {
                  "id": 1190,
                  "user": "ad963267-614f-486d-a713-fb4186bcd989",
                  "playerid": "100000113",
                  "deviceid": "9b473f12d3441fb6144bdb587a999d99",
                  "time": "1742980602"
                }, {
                  "id": 1191,
                  "user": "b1877ddc-89f9-4e3a-b431-c20bc774c81b",
                  "playerid": "100000903",
                  "deviceid": "b4b79b04c66cd05935e1d699b9a556b4",
                  "time": "1742991826"
                }, {
                  "id": 1192,
                  "user": "b3bd9864-ef41-40da-b620-612b860aed69",
                  "playerid": "100000953",
                  "deviceid": "1cf963fbd31e511f86fd2b984eb01bea",
                  "time": "1742994521"
                }, {
                  "id": 1193,
                  "user": "bbf78b92-52d6-42e6-87a0-dddfa7d8912c",
                  "playerid": "100000015",
                  "deviceid": "8d02118065089af44b3b1481db6de63a",
                  "time": "1742966999"
                }, {
                  "id": 1194,
                  "user": "bec68a91-0e61-45b7-937c-14ae2cbf5299",
                  "playerid": "100000046",
                  "deviceid": "858d76e87792ed0c334248644d4fd4d1",
                  "time": "1742977632"
                }, {
                  "id": 1195,
                  "user": "c007ef16-42ca-48dc-93cc-148c348c66b8",
                  "playerid": "100000414",
                  "deviceid": "057e9e247a56a5ecb658a00e87e19681",
                  "time": "1742985228"
                }, {
                  "id": 1196,
                  "user": "c1ea547c-fcd2-4b93-9dbf-13654da81371",
                  "playerid": "100000721",
                  "deviceid": "3adf73eaaa42e0b8ae25a57f226b1f38",
                  "time": "1742988554"
                }, {
                  "id": 1197,
                  "user": "c2669257-2640-4676-a0ab-7feca4518acf",
                  "playerid": "100001018",
                  "deviceid": "64b9fb9be8061ebe2aa5645010d298d8",
                  "time": "1743001680"
                }, {
                  "id": 1198,
                  "user": "c3b037cd-868b-4da6-8026-ea45ef86f75a",
                  "playerid": "100000417",
                  "deviceid": "c0c9b5cc794c9765c43eddf9e7cd5d35",
                  "time": "1742985238"
                }, {
                  "id": 1199,
                  "user": "c98477b5-ea6d-4e76-a328-3f5309b4b916",
                  "playerid": "100000357",
                  "deviceid": "feb069c9722f8a58e7191f8e5ac54890",
                  "time": "1742984897"
                }, {
                  "id": 1200,
                  "user": "d6f9db29-99ed-43d9-8ecf-cc8cdd53a263",
                  "playerid": "100000504",
                  "deviceid": "31f889999921114f7606a8052dce5aff",
                  "time": "1742985874"
                }, {
                  "id": 1201,
                  "user": "d722242b-094f-4388-b341-807309484069",
                  "playerid": "100000480",
                  "deviceid": "988f8474d277e3aadc4ef66765f2facb",
                  "time": "1742985551"
                }, {
                  "id": 1202,
                  "user": "d8176495-8bb4-429e-bc2d-e702544531d4",
                  "playerid": "100000481",
                  "deviceid": "d1ac2477b79c5a40b4f01fa5cb9f7d2a",
                  "time": "1742985551"
                }, {
                  "id": 1203,
                  "user": "df48367a-0ce2-4800-94c6-95273dfeacd4",
                  "playerid": "100001092",
                  "deviceid": "b61134dd38b4925b05f30e4771e66fc4",
                  "time": "1743035911"
                }, {
                  "id": 1204,
                  "user": "e4bb6318-7d0b-45ab-9be3-5552ea30457d",
                  "playerid": "100000623",
                  "deviceid": "",
                  "time": "1742986919"
                }, {
                  "id": 1205,
                  "user": "e704f8e4-bfec-4aa5-a523-74bb1273a901",
                  "playerid": "100000416",
                  "deviceid": "f342c94d9f05a72f320faaffc3473d7e",
                  "time": "1742985229"
                }, {
                  "id": 1206,
                  "user": "efdde62f-7b5f-4f05-87d1-9f32e5ec6fb0",
                  "playerid": "100000947",
                  "deviceid": "50c2b8f5630f75fc36bf4248c1f2981c",
                  "time": "1742994147"
                }, {
                  "id": 1207,
                  "user": "f63e7179-823f-4e20-ab27-a6b160833c04",
                  "playerid": "100000268",
                  "deviceid": "a6d2bc981a1773092be6f2724603e8be",
                  "time": "1742983921"
                }, {
                  "id": 1208,
                  "user": "f6401586-0b58-495b-9644-ccf91d98ae35",
                  "playerid": "100000904",
                  "deviceid": "f634e3dff1ac386239e44cc7f8dc0b16",
                  "time": "1742991837"
                }];
                funcList = ['register'];
                i = 0;

              case 3:
                if (!(i < dataList.length)) {
                  _context.next = 17;
                  break;
                }

                k = 0;

              case 5:
                if (!(k < funcList.length)) {
                  _context.next = 14;
                  break;
                }

                reqData = _objectSpread({}, _this2[funcList[k]]);

                for (h in _this2[funcList[k]]) {
                  if (h == 'timestamp') {
                    reqData.timestamp = parseInt(dataList[i].time);
                  }

                  if (h == 'device_id') {
                    reqData.device_id = dataList[i].deviceid;
                  }

                  if (h == 'role_id') {
                    reqData.role_id = dataList[i].playerid;
                  }

                  if (h == 'user_id') {
                    reqData.user_id = dataList[i].user;
                  }
                }

                console.log(reqData);
                _context.next = 11;
                return axios.post('https://data.colocess.com/api/data/report', reqData).then(function (res) {
                  if (res.data.code == 1000) {
                    _this2.$message('上报成功');
                  }
                });

              case 11:
                k++;
                _context.next = 5;
                break;

              case 14:
                i++;
                _context.next = 3;
                break;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};